import {doc} from './docs.js';

doc(
    "print",
    {
        "message": "to print",
    },
    "prints to javascript console");

export const print = () => ([msg]) => console.log(msg);
